import { AppTag } from "@lib/components/AppComponents";
import IntlMessages from "@lib/helpers/IntlMessages";

type Props = {
  isDisabled: boolean;
  size?: "small" | "default";
};

const IsDisabledTag = (props: Props) => {
  const { isDisabled } = props;

  return (
    <AppTag color={isDisabled ? "red" : "green"}>
      <IntlMessages id={isDisabled ? "common.disabled" : "common.enabled"} />
    </AppTag>
  );
};

export default IsDisabledTag;
